import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is already logged in (using sessionStorage)
    const authStatus = sessionStorage.getItem('ns2_auth');
    const username = sessionStorage.getItem('ns2_user');
    
    if (authStatus === 'true' && username) {
      setIsAuthenticated(true);
      setUser({ username });
    }
    setLoading(false);
  }, []);

  const login = () => {
    setIsAuthenticated(true);
    const username = sessionStorage.getItem('ns2_user');
    setUser({ username });
  };

  const logout = () => {
    sessionStorage.removeItem('ns2_auth');
    sessionStorage.removeItem('ns2_user');
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    isAuthenticated,
    loading,
    user,
    login,
    logout
  };
};

